export default "__VITE_ASSET__Byiicyz6__"